import { notifications } from "@mantine/notifications"

interface NotifyOptions {
  title?: string
  message?: string
  t: (key: string) => string
}

export function notifySuccess({ t, message, title }: NotifyOptions) {
  return notifications.show({
    color: "green",
    title: title ?? t("Success"),
    message: message ?? t("The operation completed successfully."),
  })
}
